<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/gXr2fK/tc-custom/9781646685974.jpg?1699705938048" alt="This image is the cover for the book Faithless III"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Faithless III
      </h1>
      <p class="bookDescription body article font2">
        <p>Faith’s descent isn’t always pretty, but it’s sexy as hell. After Faith’s paintings take the art world by storm, she vanishes as quickly as she comes, leaving tongues wagging. Is her disappearance a wild publicity stunt, a cry for help from an uninitiated artist, or something altogether too sinister to fathom? With Louis Thorne behind her catastrophic rise to stardom… who’s really to say? Faith and the devil go head-to-head in this final chapter of New York Times bestseller Brian Azzarello (Moonshine, Batman: Damned) and Maria Llovet’s (Luna, Heartbeat) erotically charged series about sexual and magical awakenings and those caught in the crosshairs of good and evil. Collects Faithless III #1-6.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Brian Azzarello, Maria Llovet
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      BOOM! Studios
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?54cbff97